// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2bcZu","title":"ClientCherryInfo_title__2A4GL","itemText":"ClientCherryInfo_itemText__2s5CM"};